/**
 * @deprecated Use GA4EventNameEnum from analytics.constants.ts instead
 * This enum is kept for backward compatibility
 */
export enum GoogleActionsEnum {
  USER_CLICKED_BTN = 'Button clicked',
}

/**
 * Google Analytics 4 Event Categories
 * @description Categories for organizing GA4 events
 */
export enum GA4CategoryEnum {
  USER_ENGAGEMENT = 'user_engagement',
  E_COMMERCE = 'ecommerce',
  BOOKING = 'booking',
  NAVIGATION = 'navigation',
  FORM_INTERACTION = 'form_interaction',
  ERROR = 'error',
}
